var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.37 11.3099V5.28792C14.3694 5.02426 14.2995 4.76539 14.1673 4.53724C14.0352 4.30909 13.8454 4.11966 13.617 3.98792L8.34902 0.970919C8.12023 0.838828 7.8607 0.769287 7.59652 0.769287C7.33234 0.769287 7.07281 0.838828 6.84402 0.970919L1.57502 3.98592C1.34663 4.11766 1.15686 4.30709 1.02471 4.53524C0.892559 4.76339 0.822663 5.02226 0.822021 5.28592V11.3069C0.822663 11.5706 0.892559 11.8294 1.02471 12.0576C1.15686 12.2857 1.34663 12.4752 1.57502 12.6069L6.84402 15.6179C7.07281 15.75 7.33234 15.8196 7.59652 15.8196C7.8607 15.8196 8.12023 15.75 8.34902 15.6179L13.622 12.6119C13.8498 12.4794 14.0387 12.2894 14.17 12.0609C14.3013 11.8324 14.3702 11.5734 14.37 11.3099V11.3099Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0249 4.50586L7.5959 8.30586L14.1669 4.50586",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59497 15.8849V8.29785",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.191,
    height: 16.635,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.56233f58afbd1e5ecfd716792596a60d.svg";
export { ForwardRef as ReactComponent };